// Mirrors scss/utility/_media-queries.scss
export const mqMedium = '(min-width: 52.125rem)';
// 834+ with a mouse or trackpad as the primary input (finepointer mixin)
export const mqFinePointer = `${mqMedium} and (hover: hover) and (pointer: fine)`;
